var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-3"},[_c('v-row',{attrs:{"row":"","wrap":""}},[_c('h1',[_vm._v(_vm._s(_vm.label))])]),_vm._v(" "),_c('v-row',{attrs:{"row":"","wrap":""}},[_c('DocumentLinkList',{attrs:{"documents":_vm.items}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }